/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-11 10:01:46
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-11 10:52:03
 */
import {useState} from "react";
import {Divider, Form, Input, message, Modal} from "antd";
import {updateTeam} from "@/api/modules/team";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {setCurrentTeam} from "@/redux/modules/global/action";

const EditTeamModal = (props: any) => {
	const {t} = useTranslation();

	const {open, onClose, currentTeam} = props;
	const dispatch = useDispatch();

	const [teamName, setTeamName] = useState();
	const [isLoading, setIsLoading] = useState(false);

	const handlerTeamNameChange = (event) => {
		setTeamName(event.target.value);
	}

	const handleOnClose = () => {
		setTeamName("");
		onClose();
	}

	const updateTeamName = () => {
		updateTeam({name: teamName}).then(res => {
			if (res.code === 200) {
				message.success(t("teamSettings.team.rename.success"));
				dispatch(setCurrentTeam({...currentTeam, name: teamName}));
				handleOnClose();
			}
		});
	};

	return (
		<Modal
			open={open}
			title={t("teamSettings.team.rename.modal.title")}
			okText={t("teamSettings.team.rename.modal.ok")}
			onOk={() => updateTeamName()}
			confirmLoading={isLoading}
			onCancel={handleOnClose}
		>
			<Divider style={{margin: 0}}/>
			<Form style={{width: "100%", marginTop: "1rem"}} labelCol={{span: 24}}>
				<Form.Item label={t("teamSettings.team.rename.modal.label")}>
					<Input
						value={teamName}
						maxLength={20}
						count={{
							show: true,
							max: 20,
						}}
						onChange={handlerTeamNameChange}/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditTeamModal;
